module.exports = __webpack_public_path__ + "static/media/story_10.e50cd376.jpg";